import { validateRequiredField } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredField';
import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';

const role = { fieldName: 'role', fieldCaption: 'Role' };
const salesRepresentative = { fieldName: 'salesRepresentative', fieldCaption: 'Sales Representative' };

export const validateVerisendForm = (values: Record<string, string>) => groupValidators(
  validateRequiredField({ ...role, value: values.role }),
  validateRequiredField({ ...salesRepresentative, value: values.salesRepresentative }),
  validateMaxLength({
    ...salesRepresentative,
    length: 128,
    value: values.salesRepresentative,
  }),
);

export default (values: Record<string, string>) => groupValidators(
  validateRequiredField({ ...role, value: values.role }),
);
